export const FOCUS_TRAP_SELECTOR = '[role="dialog"][aria-modal="true"]'
